import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "font-display font-semibold border border-primary text-gold-700 bg-transparent hover:bg-primary/10 active:bg-primary/20",
        destructive:
          "font-display font-semibold border border-destructive text-destructive bg-transparent hover:bg-destructive/10 active:bg-destructive/20",
        outline:
          "font-display font-semibold border border-input bg-transparent hover:bg-foreground/5 active:bg-foreground/10",
        secondary:
          "font-display font-semibold border border-input text-foreground bg-transparent hover:bg-foreground/5 active:bg-foreground/10",
        ghost: "font-display font-semibold text-gold-700 hover:bg-primary/10",
        link: "text-gold-700 underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
